var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "inherit",
  fillRule: "evenodd",
  d: "M4.55 20V4c0-1.65 1.35-3 3-3h8.94c1.65 0 3 1.35 3 3v16c0 1.65-1.35 3-3 3H7.55c-1.65 0-3-1.35-3-3m2-16v16c0 .55.45 1 1 1h8.94c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1H7.55c-.55 0-1 .45-1 1",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "inherit",
  d: "M12.008 18c-.555 0-1.008.45-1.008 1s.453 1 1.008 1 1.007-.45 1.007-1-.453-1-1.007-1M14 4h-3.996a.503.503 0 0 0-.504.5c0 .275.227.5.504.5H14a.503.503 0 0 0 .504-.5c0-.275-.227-.5-.504-.5"
})));
export default SvgMobile;